module.exports = __webpack_public_path__ + "DINNextLTPro-MediumItalic.woff?4d7d28d59e6376ca243ae3533fa96f04";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-MediumItalic.woff
// module id = 1437
// module chunks = 0